const JOB_DETAILS_PATHS_THAT_ONLY_FAIL_WHEN_THE_JOB_IS_GONE = [
  'add_on_charges',
  'file_attachments',
  'files',
  'invoicing',
  'job_events',
  'loads',
  'loads/cycles',
  'resource_usage_logs',
  'signatures',
  'site_usages',
  'tickets',
];

const JOB_DETAILS_URL_REGEX = new RegExp(
  `/v1/companies/[\\w-]{36}/jobs/([\\w-]{36})(?:/(?:${JOB_DETAILS_PATHS_THAT_ONLY_FAIL_WHEN_THE_JOB_IS_GONE.join('|')}))?$`,
);

interface FailedRequest {
  method?: string;
  status?: number;
  url?: string;
}

export default function getJobIdFromJobDetailsUrl(url: string) {
  const [urlWithoutQuery] = url.split('?');

  return JOB_DETAILS_URL_REGEX.exec(urlWithoutQuery)?.[1];
}

export function getGoneJobIdFromFailedRequest({ method, status, url }: FailedRequest) {
  const isNotFound = status === 404;
  const isGetRequest = method?.toUpperCase() === 'GET';

  if (!isNotFound || !isGetRequest) {
    return undefined;
  }

  return getJobIdFromJobDetailsUrl(url ?? '');
}
